<template>
<div>
    <!-- <banner></banner> -->
    <div class="main">
    <div class="titleHeader">
      <img class="sizePressImg" src="../../assets/img/press.png" alt="" />
      <span class="titleText">出版社</span>
    </div>
    <div>
      <ul class="clearfix">
        <li
          class="pressli left"
          :key="index"
          v-for="(item, index) in pressData"
          @click="gotoUrl(item.skypegmwcnUrl)"
        >
          <div class="pressImgdiv">
            <img class="pressImg" :src="item.logo?item.logo:require('../../assets/img/deficon.png')" alt="" />
          </div>
          <p class="pressNametext">{{ item.name }}</p>
        </li>
      </ul>
      <div class="block">
        <!-- <el-pagination
          layout="prev, pager, next"
          :total="total"
          :page-size="pageParam.pageSize"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        ></el-pagination> -->
      </div>
    </div>
  </div>
</div>
</template>
<script>
// import Banner from '@/components/home/banner.vue'
import { mapMutations, mapState, mapGetters } from 'vuex'
import { selectProvincePress } from '../../api/home/index.js'
export default {
  // components: {
  //   Banner,
  // },
  data() {

    return {
      pageParam: {
        platformId:'',
      },
      pressData: [],
      total: 0,
    }
  },
  computed: {
    ...mapGetters(['resStatus', 'resBookSelectionAuthority','resSchoolId']),
  },
  created() {
    this.pageParam.platformId = this.resSchoolId ? this.resSchoolId :'';
    this.getDataList(this.pageParam)
  },
  methods: {
    getDataList(param) {
      selectProvincePress(param)
        .then((res) => {
          if (res.status == 0) {
            this.pressData = res.data
            this.total = res.page.total
          }
        })
        .catch(() => {})
    },
    gotoUrl(url) {
      if (url) {
        window.open(url)
      }else{
        this.$message.info('暂无官网信息')
      }
      
    },
    handleSizeChange(newSize) {},
    handleCurrentChange(newPage) {
      this.pageParam.pageNo = newPage
      this.getDataList(this.pageParam)
    },
  },
}
</script>

<style lang="scss" scoped>
.main{
  // min-height: 900px;
  // position:absolute;
  // top: 120px;
  // min-height: 900px !important;
  // bottom: 0px;
}
.titleText {
  display: inline-block;
  vertical-align: middle;
  margin-left: 5px;
}
.sizePressImg {
  width: 26px;
  height: 19px;
  display: inline-block;
  vertical-align: middle;

}
.titleHeader {
  border-bottom: 1px solid #0082F0;
  height: 25px;
  margin-top: 20px;
}
.pressImg {
  width: 190px;
  height: 56px;
  margin-top: 30px;
  object-fit: contain;
}
.pressNametext {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #666666;
  line-height: 20px;
  text-align: center;
  margin-top: 10px;
}
.pressImgdiv {
  width: 275px;
  height: 117px;
  background: #ffffff;
  border: 1px solid #e6e6e6;
  text-align: center;
}
.block{
  position: absolute;
  bottom: 70px;
}
.pressli:nth-child(4n) {
  margin-right: 0;
}
.pressli {
  width: 275px;
  height: 170px;
  margin-right: 20px;
  margin-top: 20px;
}
</style>

